module.exports = `{
  "answers": [
    {
      "type": "text",
      "text": "What do you mean...
        African or European?"
    }
  ]
}`
